import React, { Component } from "react";

class Print_RaumBuchProduct extends Component {
	state = {};
	render() {
		return (
			<div className="RBuch-Product-Print">
				<span className="RBuch-ObjectName-Print">Boden</span>
				<img
					className="RBuch-ProductImage-Print"
					src="https://unreal.home-klick.dev/admin/products/images/Eiche_Classic.jpeg"
				/>
				<div className="RBuch-ProductMiddle-Print">
					<span className="RBuch-ProductMaterial-Print">Holz</span>
					<span className="RBuch-ProductName-Print">
						Eiche Classic, Schiffsboden, 2-Schicht, 14 mm
					</span>
					<span className="RBuch-ProductBuilder-Print">
						Manufacturer: Bembe Parkett GmbH & Co. KG
					</span>
					<span className="RBuch-ProductDesc-Print">
						Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
						eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
						ad minim veniam, quis nostrud exercitation ullamco laboris.
					</span>
				</div>
				<div className="RBuch-ProductRightCol-Print">
					<span>Surcharge</span>
					<span>3.010,00 €</span>
				</div>
			</div>
		);
	}
}

export default Print_RaumBuchProduct;
